(function initShadeMatchAutoSelect() {

  // Set DEBUG = true in browser console to re-enable logging: window.__SHADE_DEBUG = true
  var DEBUG = false;

  var WORKER_URL = 'https://subtl-shade-match.rachel-08e.workers.dev';

  function log() {
    if (DEBUG || window.__SHADE_DEBUG) console.log.apply(console, ['[ShadeMatch]'].concat(Array.prototype.slice.call(arguments)));
  }

  // ── State ──────────────────────────────────────────────────────────────────
  var appliedConversationId = '';
  // Cached recs from the most recent successful /shades response. Used to
  // reapply when the quiz reveals its result products (see setupQuizReapply).
  var lastFetchedRecs = null;

  function getConversationId() {
    try {
      var state = JSON.parse(localStorage.getItem('kustomerState') || '{}');
      return state.lastOpenConversationId || '';
    } catch (e) { return ''; }
  }

  function getCurrentProductHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  // ── Worker polling ─────────────────────────────────────────────────────────
  function pollWorker() {
    var convId = getConversationId();
    if (!convId || convId === appliedConversationId) return;

    fetch(WORKER_URL + '/shades?conversationId=' + encodeURIComponent(convId))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        log('Worker response:', JSON.stringify(data));
        if (!data.found || !data.recommendations || !data.recommendations.length) return;

        appliedConversationId = convId;
        lastFetchedRecs = data.recommendations;
        applyRecommendations(data.recommendations);
      })
      .catch(function (e) { log('Worker poll error:', e.message); });
  }

  setInterval(pollWorker, 2000);

  // Trigger an immediate poll on any Kustomer SDK event
  function waitForKustomer(cb, attempts) {
    attempts = attempts || 0;
    var core = window.KustomerCore || window.Kustomer;
    if (core && core.addListener) {
      log('Kustomer SDK ready');
      return cb(core);
    }
    if (attempts > 40) { log('Kustomer SDK not found after 20s'); return; }
    setTimeout(function () { waitForKustomer(cb, attempts + 1); }, 500);
  }

  waitForKustomer(function (core) {
    ['onUnread', 'onConversationCreate'].forEach(function (evt) {
      try {
        core.addListener(evt, function () { pollWorker(); });
      } catch (e) {
        log(evt + ' registration failed:', e.message);
      }
    });
  });

  // ── Quiz reveal: reapply when .quiz-result-products mutates ───────────────
  // On the quiz page, .quiz-result-products is in the DOM on load but its
  // product cards are gated until the user finishes the quiz or clicks
  // "Get Result". At that point the quiz JS injects/reveals cards and sets
  // its own default shades, which would override anything we applied
  // earlier. We watch the container for DOM changes and re-apply the
  // cached recs (debounced). Each apply branch is idempotent against an
  // already-selected swatch, so this won't loop.
  function setupQuizReapply(attempts) {
    attempts = attempts || 0;
    if (!isQuizPage()) return;
    var container = document.querySelector('.quiz-result-products');
    if (!container) {
      if (attempts > 30) { log('Quiz: .quiz-result-products never appeared, giving up'); return; }
      setTimeout(function () { setupQuizReapply(attempts + 1); }, 1000);
      return;
    }

    var debounceTimer = null;
    var observer = new MutationObserver(function () {
      if (!lastFetchedRecs || !lastFetchedRecs.length) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        log('Quiz: DOM change in .quiz-result-products, reapplying recs');
        applyRecommendations(lastFetchedRecs);
      }, 500);
    });

    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden'],
    });
    log('Quiz reapply observer attached');
  }
  setupQuizReapply();

  // ── Apply all recommendations ──────────────────────────────────────────────

  // On the quiz result page only BB Powder and Concealer are overridden;
  // everything else keeps the quiz's own recommendation.
  var QUIZ_HANDLES = ['bb-powder', 'concealer'];

  function isQuizPage() {
    return window.location.pathname.indexOf('/pages/quiz') !== -1;
  }

  function applyRecommendations(recommendations) {
    log('Applying', recommendations.length, 'recommendations');

    if (isQuizPage()) {
      recommendations = recommendations.filter(function (rec) {
        return QUIZ_HANDLES.some(function (h) { return rec.handle.indexOf(h) !== -1; });
      });
      log('Quiz page — filtered to', recommendations.length, 'recommendations');
    }

    var currentHandle = getCurrentProductHandle();
    var toastItems = [];

    recommendations.forEach(function (rec) {
      var applied = false;

      // PDP: current page is this product — use dropdown/swatch
      if (currentHandle && currentHandle === rec.handle) {
        applied = applyShadeOnPDP(rec.shade);
        if (applied) toastItems.push({ label: rec.shade, shade: rec.shade });
      }

      // Grid: find product cards via links and click their swatch
      if (!applied) {
        var gridApplied = applyShadeOnGrid(rec);
        if (gridApplied) {
          applied = true;
          toastItems.push({ label: rec.shade, shade: rec.shade });
        }
      }

      if (!applied) {
        var globalApplied = applyShadeGlobally(rec.shade);
        if (globalApplied) toastItems.push({ label: rec.shade, shade: rec.shade });
      }
    });

    if (toastItems.length) showConfirmationToast(toastItems);
  }

  // ── Radio click + overflow expand helper ──────────────────────────────────

  // Grid swatch lists hide swatches past N (6 desktop / 4 mobile, varies by
  // breakpoint) via CSS, with a "+X" overflow-note that the theme's
  // custom-events.js binds a click handler to which un-hides everything. When
  // our matched swatch is in the hidden tail, we click that note first so the
  // selected swatch is actually visible to the user, then click the label.
  function clickRadioLabel(radio) {
    if (!radio) return false;
    var li = radio.closest('li');
    if (li && window.getComputedStyle(li).display === 'none') {
      var list = li.parentElement;
      var overflow = list && list.querySelector('.product-swatches-options__item-overflow-note');
      if (overflow) {
        log('Expanding overflow note to reveal swatch');
        overflow.click();
      }
    }
    var label = document.querySelector('label[for="' + radio.id + '"]');
    if (!label) return false;
    label.click();
    return true;
  }

  // ── PDP: swatch button or hidden select ───────────────────────────────────

  function applyShadeOnPDP(shadeName) {
    return applyShadeViaSwatch(document, shadeName) || applyShadeViaSelect(document, shadeName);
  }

  // ── Grid: find the product card and click its swatch ─────────────────────

  function applyShadeOnGrid(rec) {
    var needle = rec.shade.trim().toUpperCase();
    var links = document.querySelectorAll('a[href*="/products/' + rec.handle + '"]');
    var applied = false;
    var seen = [];

    for (var i = 0; i < links.length; i++) {
      var card = links[i].closest(
        'li, article, [data-product], .product-item, .product-card, .grid__item, ' +
        '.product-row, [class*="stak-item"], [class*="bundle-item"], [class*="kit-item"]'
      );

      // Fallback: walk up the DOM looking for a container that has swatches or selects
      if (!card) {
        var el = links[i].parentElement;
        for (var k = 0; k < 6 && el; k++) {
          if (el.querySelector('button[data-option-value], select[name^="options["], input[type="radio"][name^="option"]')) {
            card = el;
            break;
          }
          el = el.parentElement;
        }
      }

      if (!card || seen.indexOf(card) !== -1) continue;
      seen.push(card);

      // 1. button[data-option-value] (PDP-style swatches)
      var swatches = card.querySelectorAll('button[data-option-value]');
      for (var j = 0; j < swatches.length; j++) {
        var val = (swatches[j].getAttribute('data-option-value') || '').trim().toUpperCase();
        if (val === needle || val.indexOf(needle) === 0) {
          log('Grid swatch click:', rec.shade, 'on', rec.handle);
          swatches[j].click();
          applied = true;
          break;
        }
      }

      // 2. input[type="radio"] + label (buildmystack-style grid swatches)
      if (!applied) {
        var radios = card.querySelectorAll('input[type="radio"][name^="option"]');
        for (var r = 0; r < radios.length; r++) {
          var radioVal = (radios[r].value || '').trim().toUpperCase();
          if (radioVal === needle || radioVal.indexOf(needle) === 0) {
            if (radios[r].checked) {
              log('Grid: radio already selected for', rec.shade, 'on', rec.handle);
              applied = true; // already correct — no click needed
            } else {
              log('Grid radio click:', radios[r].value, 'on', rec.handle);
              if (clickRadioLabel(radios[r])) applied = true;
            }
            break;
          }
        }
      }

      // 3. select[name^="options["] (bundle page dropdowns)
      if (!applied) {
        var selects = card.querySelectorAll('select[name^="options["]');
        for (var s = 0; s < selects.length; s++) {
          var select = selects[s];
          for (var o = 0; o < select.options.length; o++) {
            var opt = select.options[o];
            var optVal = opt.value.trim().toUpperCase();
            var optTxt = opt.text.trim().toUpperCase();
            if (optVal === needle || optTxt === needle || optVal.indexOf(needle) === 0 || optTxt.indexOf(needle) === 0) {
              log('Grid select match:', opt.value, 'on', rec.handle);
              select.value = opt.value;
              select.dispatchEvent(new Event('change', { bubbles: true }));
              applied = true;
              break;
            }
          }
          if (applied) break;
        }
      }

      if (!applied) {
        log('Grid: no match for', rec.shade, 'in', rec.handle,
          '| buttons:', swatches.length,
          '| radios:', card.querySelectorAll('input[type="radio"][name^="option"]').length,
          '| selects:', card.querySelectorAll('select[name^="options["]').length);
      }
    }

    return applied;
  }

  // ── Global fallback: scan all selects on page by shade name ──────────────

  function applyShadeGlobally(shadeName) {
    var needle = shadeName.trim().toUpperCase();

    // Premade/bundle pages (e.g. starter-stak-deluxe) use a custom dropdown
    // with buttons inside a hidden panel. Clicking the button triggers the
    // theme JS that updates the visible label and underlying select.
    var buttons = document.querySelectorAll('button[data-option-value]');
    for (var i = 0; i < buttons.length; i++) {
      var val = (buttons[i].getAttribute('data-option-value') || '').trim().toUpperCase();
      if (val === needle || val.indexOf(needle) === 0) {
        if (buttons[i].classList.contains('selected')) {
          log('Global: swatch already selected for', shadeName);
          return false;
        }
        log('Global swatch click:', buttons[i].getAttribute('data-option-value'));
        buttons[i].click();
        return true;
      }
    }

    // Grid swatches on featured-collection / buildmystack cards are radio
    // inputs (input[name="option-0"][value="Shade Name"]) with a label that
    // triggers the variant change on click.
    var radios = document.querySelectorAll('input[type="radio"][name^="option"]');
    for (var r = 0; r < radios.length; r++) {
      var radioVal = (radios[r].value || '').trim().toUpperCase();
      if (radioVal === needle || radioVal.indexOf(needle) === 0) {
        if (radios[r].checked) {
          log('Global: radio already selected for', shadeName);
          return false;
        }
        log('Global radio click:', radios[r].value);
        if (clickRadioLabel(radios[r])) return true;
      }
    }

    // Fallback: change a <select> element directly (covers simpler bundle setups).
    var selects = document.querySelectorAll('select');
    for (var s = 0; s < selects.length; s++) {
      var select = selects[s];
      for (var j = 0; j < select.options.length; j++) {
        var opt = select.options[j];
        var optVal = opt.value.trim().toUpperCase();
        var optTxt = opt.text.trim().toUpperCase();
        if (optVal === needle || optTxt === needle || optVal.indexOf(needle) === 0 || optTxt.indexOf(needle) === 0) {
          if (select.value.trim().toUpperCase() === optVal) {
            log('Global: shade already set to', opt.value);
            return false;
          }
          log('Global select match:', opt.value);
          select.value = opt.value;
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
    }

    log('Global: no match for', shadeName);
    return false;
  }

  // ── Shared shade helpers ───────────────────────────────────────────────────

  function applyShadeViaSwatch(scope, shadeName) {
    var needle = shadeName.trim().toUpperCase();
    var buttons = scope.querySelectorAll('button[data-option-value]');
    for (var i = 0; i < buttons.length; i++) {
      var val = (buttons[i].getAttribute('data-option-value') || '').trim().toUpperCase();
      if (val === needle || val.indexOf(needle) === 0) {
        log('PDP swatch click:', buttons[i].getAttribute('data-option-value'));
        buttons[i].click();
        buttons[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
        return true;
      }
    }
    return false;
  }

  function applyShadeViaSelect(scope, shadeName) {
    var needle = shadeName.trim().toUpperCase();
    var selects = scope.querySelectorAll('select[name^="options["]');
    for (var i = 0; i < selects.length; i++) {
      var select = selects[i];
      for (var j = 0; j < select.options.length; j++) {
        var o = select.options[j];
        var val = o.value.trim().toUpperCase();
        var txt = o.text.trim().toUpperCase();
        if (val === needle || txt === needle || val.indexOf(needle) === 0 || txt.indexOf(needle) === 0) {
          log('PDP select match:', o.value);
          select.value = o.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
    }
    return false;
  }

  // ── Toast ──────────────────────────────────────────────────────────────────

  function showConfirmationToast(selected) {
    var existing = document.querySelector('#subtl-shade-toast');
    if (existing) existing.remove();

    var shadeLines = selected.map(function (s) {
      return '<strong>' + s.shade + '</strong>';
    }).join(', ');

    var toast = document.createElement('div');
    toast.id = 'subtl-shade-toast';
    toast.innerHTML = [
      '<div style="display:flex;align-items:flex-start;gap:10px;">',
        '<span style="font-size:18px;line-height:1;">🎨</span>',
        '<div>',
          '<div style="font-size:12px;font-weight:500;margin-bottom:4px;">Shades selected for you</div>',
          '<div style="font-size:11px;line-height:1.8;">' + shadeLines + '</div>',
        '</div>',
        '<button onclick="this.parentElement.parentElement.remove()" ',
          'style="background:none;border:none;color:rgba(255,255,255,.5);cursor:pointer;font-size:16px;margin-left:auto;padding:0;line-height:1;">×</button>',
      '</div>',
    ].join('');

    toast.style.cssText = [
      'position:fixed',
      'bottom:90px',
      'left:50%',
      'transform:translateX(-50%)',
      'background:#3D0C1F',
      'color:#fff',
      'padding:12px 16px',
      'border-radius:6px',
      'font-size:13px',
      'z-index:9999',
      'box-shadow:0 4px 20px rgba(0,0,0,0.25)',
      'min-width:240px',
      'max-width:320px',
      'animation:subtl-fadein .3s ease',
    ].join(';');

    if (!document.querySelector('#subtl-shade-styles')) {
      var style = document.createElement('style');
      style.id = 'subtl-shade-styles';
      style.textContent = '@keyframes subtl-fadein{from{opacity:0;transform:translateX(-50%) translateY(8px)}to{opacity:1;transform:translateX(-50%) translateY(0)}}';
      document.head.appendChild(style);
    }

    document.body.appendChild(toast);
    setTimeout(function () { if (toast.parentNode) toast.remove(); }, 6000);
  }

})();
